// Page Me — links into the app. Imported for side effects from App.vue, which
// main.js loads before `deeplink.start(router)` replays the launch URL.
//
//   /add/<code>, /app/add/<code>, /tabs/add/<code>  → Invite (pairs with that pager)
//   bus 'pm:open-thread' <number>                    → Thread with that friend
//   bus 'pm:open-group' <groupId>                    → that group's thread

import { defineLinks } from '../core/deeplink.js';
import { bus } from '../core/state.js';
import router from '../router.js';

const CODE = /^[0-9A-Za-z]{4,16}$/;

/** '/add/K7QX9MFD' (any of the accepted prefixes) → the code, or null. */
export function inviteCodeFrom(pathname) {
  const m = /^\/(?:app\/|tabs\/)?add\/([^/?#]+)\/?$/.exec(String(pathname ?? ''));
  if (!m) return null;
  let code;
  try { code = decodeURIComponent(m[1]); } catch { return null; }
  return CODE.test(code) ? code.toUpperCase() : null;
}

export const LINKS = [
  {
    name: 'invite',
    match: ({ pathname }) => {
      const code = inviteCodeFrom(pathname);
      return code ? { name: 'invite', params: { code } } : null;
    },
    href: ({ code }) => (code ? `/add/${encodeURIComponent(code)}` : null),
  },
];

defineLinks(LINKS);

bus.on('pm:open-thread', (number) => {
  if (!/^\d{10}$/.test(String(number ?? ''))) return;
  try { router.push({ name: 'thread', params: { number: String(number) } }); } catch { /* ignore */ }
});

bus.on('pm:open-group', (id) => {
  if (!/^[A-Za-z0-9_-]{6,32}$/.test(String(id ?? ''))) return;
  try { router.push({ name: 'group', params: { id: String(id) } }); } catch { /* ignore */ }
});
